<template>
    <x-app class="layout-home-sample">
        <x-navbar v-if="!isFullscreen" :schema="schema.navbar"></x-navbar>
    
        <!--<x-sidebar :schema="schema.navbar"></x-sidebar> -->

        <template v-slot:content>
            <transition name="fade" mode="out-in" appear>
                <!-- <x-page-view :schema="schema.pageview"></x-page-view> -->
                <x-page-view :schema="schema.pageview" :use-full-page-class="!isDashboardRoute"></x-page-view>
            </transition>
        </template>

        <x-quickbar></x-quickbar>

        <x-footerbar v-if="!isFullscreen" :schema="schema.footerbar"></x-footerbar>
    </x-app>
</template>

<script>
import { treeMenuItems } from '@/navigation/tree-menu';

export default {
    name: 'LayoutHome',
    data() {
        return {
            isFullscreen: false,
            schema: {
                navbar: {
                    color: 'thirteen',
                    left: [
                        {
                            type: 'dropdown-navigation-tree',
                            icon: 'mdi-dots-grid',
                            hint: 'atalhos.navegacao',
                            disabled: false,
                            class: '', 
                            modulesPanelTree: {
                                title: 'navigation.modules.title',
                                minWidth: 300, // Ajuste da largura mínima do TreeView
                                maxWidth: 300, // Ajuste da largura máxima do TreeView
                                items: treeMenuItems                            
                            },
                            // historyPanel: {
                            //     title: 'navigation.history.title',
                            //     minWidth: null,
                            //     maxWidth: null,
                            //     items: [
                            //         {
                            //             label: 'Grupos de Usuários',
                            //             hint: 'Grupos de Usuários',
                            //             disabled: false,
                            //             to: null
                            //         },
                            //         {
                            //             label: 'Usuários',
                            //             hint: 'Usuários',
                            //             disabled: false,
                            //             to: null
                            //         },
                            //         {
                            //             label: 'Análises Gerenciais',
                            //             hint: 'Análises Gerenciais',
                            //             disabled: false,
                            //             to: null
                            //         },
                            //         {
                            //             label: 'Relatórios',
                            //             hint: 'Relatórios',
                            //             disabled: false,
                            //             to: null
                            //         },
                            //     ]
                            // },
                        },
                        {
                            type: 'button',
                            icon: 'mdi-home-outline',
                            // hint: 'dashboard',
                            disabled: false,
                            class: '',
                            to: { name: 'home' }
                        },
                        {
                            type: 'dropdown-navigation',
                            hint: 'Atalhos de Navegação',
                            icon: 'mdi-dots-grid',
                            disabled: false,
                            class: '',
                            modulesPanel: {
                                title: 'navigation.modules.title',
                                minWidth: null,
                                maxWidth: null,
                                items: [
                                    /*descomentar assim que liberar*/
                                    // {
                                    //     label: ('modules.reports.label'),
                                    //     hint: ('modules.reports.label'),
                                    //     icon: 'mdi-finance',
                                    //     // image: require('@/assets/imgs/icons/1.png'),
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_reports' },
                                    // },
                                    // {
                                    //     label: ('modules.countries.label'),
                                    //     hint: ('modules.countries.label'),
                                    //     icon: 'mdi-flag',
                                    //     // image: require('@/assets/imgs/icons/1.png'),
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_paises' },
                                    // },
                                    // {
                                    //     label: ('modules.originDocuments.label'),
                                    //     hint: ('modules.originDocuments.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_documentosDeOrigem' },
                                    // },
                                    // {
                                    //     label: ('modules.divisoes.label'),
                                    //     hint: ('modules.divisoes.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_divisoes' },
                                    // },
                                    // {
                                    //     label: ('modules.gruposBancos.label'),
                                    //     hint: ('modules.gruposBancos.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_gruposDeBancos' },
                                    // },
                                    // {
                                    //     label: ('modules.departamentos.label'),
                                    //     hint: ('modules.departamentos.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_departamentos' },
                                    // },
                                    // {
                                    //     label: ('modules.moedas.label'),
                                    //     hint: ('modules.moedas.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_moedas' },
                                    // },
                                    // {
                                    //     label: ('modules.instrumentosBancarios.label'),
                                    //     hint: ('modules.instrumentosBancarios.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_instrumentosBancarios' },
                                    // },
                                    // {
                                    //     label: ('modules.calendarios.label'),
                                    //     hint: ('modules.calendarios.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_calendarios' },
                                    // },
                                    // {
                                    //     label: ('modules.gruposUnidadesNegocios.label'),
                                    //     hint: ('modules.gruposUnidadesNegocios.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_gruposUnidadesNegocios' },
                                    // },
                                    // {
                                    //     label: ('modules.gruposDeMoedas.label'),
                                    //     hint: ('modules.gruposDeMoedas.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_gruposDeMoedas' },
                                    // },
                                    // {
                                    //     label: ('modules.tiposDeContasFinanceiras.label'),
                                    //     hint: ('modules.tiposDeContasFinanceiras.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_tiposDeContasFinanceiras' },
                                    // },
                                    // {
                                    //     label: ('modules.contasContabeis.label'),
                                    //     hint: ('modules.contasContabeis.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_contasContabeis' },
                                    // },
                                    // {
                                    //     label: ('modules.planosContasAlternativas.label'),
                                    //     hint: ('modules.planosContasAlternativas.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_planosContasAlternativos' },
                                    // },
                                    // {
                                    //     label: ('corretoras'),
                                    //     hint: ('corretoras'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_corretoras' },
                                    // },
                                    // {
                                    //     label: ('modules.bancos.label'),
                                    //     hint: ('modules.bancos.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_bancos' },
                                    // },
                                    // {
                                    //     label: ('modules.beneficiariosRemetentes.label'),
                                    //     hint: ('modules.beneficiariosRemetentes.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_beneficiariosRemetentes' },
                                    // },
                                    // {
                                    //     label: ('modules.contasFinanceirasXContabeis.label'),
                                    //     hint: ('modules.contasFinanceirasXContabeis.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_contasFinanceirasXContabeis' },
                                    // },
                                    // {
                                    //     label: ('modules.unidadesDeNegocios.label'),
                                    //     hint: ('modules.unidadesDeNegocios.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_unidadesDeNegocios' },
                                    // },
                                    // {
                                    //     label: ('modules.seguradoras.label'),
                                    //     hint: ('modules.seguradoras.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_seguradoras' },
                                    // },
                                    // {
                                    //     label: ('modules.empresas.label'),
                                    //     hint: ('modules.empresas.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_empresas' },
                                    // },
                                    // {
                                    //     label: ('paridade'),
                                    //     hint: ('paridade'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_paridade' },
                                    // },
                                    // {
                                    //     label: ('modules.contasEconomicas.label'),
                                    //     hint: ('modules.contasEconomicas.label'),
                                    //     //icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: { name: 'home_contasEconomicas' },
                                    // },
                                    // {
                                    //     label: ('modules.entradaMovimentos.label'),
                                    //     hint: ('modules.entradaMovimentos.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_entradaMovimentos'}
                                    // },
                                    /*descomentar assim que liberar*/
                                    // {
                                    //     label: ('modules.movimentosCaixa.EntradaManual.label'),
                                    //     hint: ('modules.movimentosCaixa.EntradaManual.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_EntradaManualCaixa'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosCaixa.movimentosEmAberto.label'),
                                    //     hint: ('modules.movimentosCaixa.movimentosEmAberto.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_MovimentosEmAbertoCaixa'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosCaixa.movimentosEmAbertoTest.label'),
                                    //     hint: ('modules.movimentosCaixa.movimentosEmAberto.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_MovimentosEmAbertoCaixaTest'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosCaixa.movimentosEmAbertoExcluidos.label'),
                                    //     hint: ('modules.movimentosCaixa.movimentosEmAbertoExcluidos.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_MovimentosEmAbertoExcluidosCaixa'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosCaixa.movimentosEfetivados.label'),
                                    //     hint: ('modules.movimentosCaixa.movimentosEfetivados.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_MovimentosEfetivadosCaixa'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosCaixa.caixaAprovacao.label'),
                                    //     hint: ('modules.movimentosCaixa.caixaAprovacao.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_CaixaAprovacao'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosCaixa.cargaDeMovimentos.label'),
                                    //     hint: ('modules.movimentosCaixa.cargaDeMovimentos.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_CaixaDeMovimentos'}
                                    // },
                                    // {
                                    //     label: ('modules.entradaDeCaptacoes.label'),
                                    //     hint: ('modules.entradaDeCaptacoes.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_entradaCaptacoes'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosPrevisao.EntradaManual.label'),
                                    //     hint: ('modules.movimentosPrevisao.EntradaManual.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_EntradaManualPrevisao'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosPrevisao.previsoesEmAberto.label'),
                                    //     hint: ('modules.movimentosPrevisao.previsoesEmAberto.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_PrevisoesEmAberto'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosPrevisao.previsoesEfetivadas.label'),
                                    //     hint: ('modules.movimentosPrevisao.previsoesEfetivadas.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_PrevisoesEfetivadas'}
                                    // },
                                    // {
                                    //     label: ('modules.movimentosPrevisao.cargaDeMovimentos.label'),
                                    //     hint: ('modules.movimentosPrevisao.cargaDeMovimentos.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_CargaDeMovimentosPrevisao'}
                                    // },
                                    // {
                                    //     label: ('modules.captacoesEmAberto.label'),
                                    //     hint: ('modules.captacoesEmAberto.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_captacoesEmAberto'}
                                    // },
                                    // {
                                    //     label: ('modules.captacoesEfetivadas.label'),
                                    //     hint: ('modules.captacoesEfetivadas.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_captacoesEfetivadas'}
                                    // },
                                    // {
                                    //     label: ('modules.grupoDeModalidades.label'),
                                    //     hint: ('modules.grupoDeModalidades.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_grupoDeModalidades'}
                                    // },
                                    // {
                                    //     label: ('modules.carencias.label'),
                                    //     hint: ('modules.carencias.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_carencias'}
                                    // },
                                    // {
                                    //     label: ('modules.grupoDeGarantias.label'),
                                    //     hint: ('modules.grupoDeGarantias.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_grupoDeGarantias'}
                                    // },
                                    // {
                                    //     label: ('modules.finalidade.label'),
                                    //     hint: ('modules.finalidade.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_finalidade'}
                                    // },
                                    // {
                                    //     label: ('modules.responsavelArea.label'),
                                    //     hint: ('modules.responsavelArea.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_responsavelArea'}
                                    // },
                                    // {
                                    //     label: ('modules.responsavelEmitente.label'),
                                    //     hint: ('modules.responsavelEmitente.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_responsavelEmitente'}
                                    // },
                                    // {
                                    //     label: ('modules.responsavelReceptor.label'),
                                    //     hint: ('modules.responsavelReceptor.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_responsavelReceptor'}
                                    // },
                                    // {
                                    //     label: ('modules.agrupamento.label'),
                                    //     hint: ('modules.agrupamento.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_agrupamento'}
                                    // },
                                    // {
                                    //     label: ('modules.obrigacao.label'),
                                    //     hint: ('modules.obrigacao.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_obrigacao'}
                                    // },
                                    // {
                                    //     label: ('modules.acao.label'),
                                    //     hint: ('modules.acao.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_acao'}
                                    // },
                                    // {
                                    //     label: ('modules.schedule.label'),
                                    //     hint: ('modules.schedule.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_schedule'}
                                    // },
                                    // {
                                    //     label: ('modules.interfaceContabil.label'),
                                    //     hint: ('modules.interfaceContabil.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_interfaceContabil'}
                                    // },
                                    // {
                                    //     label: ('modules.integracoesDePara.label'),
                                    //     hint: ('modules.integracoesDePara.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_integracoesDePara'}
                                    // },
                                    // {
                                    //     label: ('modules.paramProgramacaoFinanceira.label'),
                                    //     hint: ('modules.paramProgramacaoFinanceira.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_paramProgramacaoFinanceira'}
                                    // },
                                    // {
                                    //     label: ('modules.taxadeMarcacaoMercado.label'),
                                    //     hint: ('modules.taxadeMarcacaoMercado.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_taxadeMarcacaoMercado'}
                                    // },
                                    // {
                                    //     label: ('modules.limites.label'),
                                    //     hint: ('modules.limites.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_limites'}
                                    // },
                                    // {
                                    //     label: ('modules.monitordeIntegracaoEntrada.label'),
                                    //     hint: ('modules.monitordeIntegracaoEntrada.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_monitordeIntegracaoEntrada'}
                                    // },
                                    // {
                                    //     label: ('modules.tipoDeCovenants.label'),
                                    //     hint: ('modules.tipoDeCovenants.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_tipoDeCovenants'}
                                    // },
                                    // {
                                    //     label: ('modules.classificacaoAgente.label'),
                                    //     hint: ('modules.classificacaoAgente.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_classificacaoAgente'}
                                    // },
                                    // {
                                    //     label: ('modules.agendamentodeProcessos.label'),
                                    //     hint: ('modules.agendamentodeProcessos.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_agendamentodeProcessos'}
                                    // },
                                    // {
                                    //     label: ('modules.historicoLimites.label'),
                                    //     hint: ('modules.historicoLimites.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_historicoLimites'}
                                    // },
                                    // {
                                    //     label: ('modules.provedoresDeIndicesEconomicos.label'),
                                    //     hint: ('modules.provedoresDeIndicesEconomicos.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_provedoresDeIndicesEconomicos'}
                                    // },
                                    // {
                                    //     label: ('modules.tabelasCustomizadas.label'),
                                    //     hint: ('modules.tabelasCustomizadas.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_tabelasCustomizadas'}
                                    // },
                                    // {
                                    //     label: ('modules.conexoesAtivas.label'),
                                    //     hint: ('modules.conexoesAtivas.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_conexoesAtivas'}
                                    // },
                                    // {
                                    //     label: ('modules.sessoesAtivas.label'),
                                    //     hint: ('modules.sessoesAtivas.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_sessoesAtivas'}
                                    // },
                                    // {
                                    //     label: ('modules.historicoExposicaoInformada.label'),
                                    //     hint: ('modules.historicoExposicaoInformada.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_historicoExposicaoInformada'}
                                    // },
                                    // {
                                    //     label: ('modules.exposicaoInformada.label'),
                                    //     hint: ('modules.exposicaoInformada.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_exposicaoInformada'}
                                    // },
                                    // {
                                    //     label: ('modules.taxasCurvaCredito.label'),
                                    //     hint: ('modules.taxasCurvaCredito.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_taxasCurvaCredito'}
                                    // },
                                    // {
                                    //     label: ('modules.gruposdeUsuarios.label'),
                                    //     hint: ('modules.gruposdeUsuarios.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_gruposdeUsuarios'}
                                    // },
                                    // {
                                    //     label: ('modules.grupos.label'),
                                    //     hint: ('modules.grupos.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_grupos'}
                                    // },
                                    // {
                                    //     label: ('modules.matrizdeAprovacao.label'),
                                    //     hint: ('modules.matrizdeAprovacao.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_matrizdeAprovacao'}
                                    // },
                                    // {
                                    //     label: ('modules.agencias.label'),
                                    //     hint: ('modules.agencias.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_agencias'}
                                    // },
                                    // {
                                    //     label: ('modules.contaCorrente.label'),
                                    //     hint: ('modules.contaCorrente.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_contaCorrente'}
                                    // },
                                    // {
                                    //     label: ('modules.usuarios.label'),
                                    //     hint: ('modules.usuarios.label'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_usuarios'}
                                    // },
                                    // {
                                    //     label: ('CaptEfetivadas5'),
                                    //     hint: ('CaptEfetivadas5'),
                                    //     icon: '',
                                    //     disabled: false,
                                    //     color: 'primary',
                                    //     to: {name: 'home_captacoesEfetivadas5'}
                                    // },
                                ]
                            },
                            // historyPanel: {
                            //     title: 'navigation.history.title',
                            //     minWidth: null,
                            //     maxWidth: null,
                            //     items: [
                            //         {
                            //             label: 'Grupos de Usuários',
                            //             hint: 'Grupos de Usuários',
                            //             disabled: false,
                            //             to: null
                            //         },
                            //         {
                            //             label: 'Usuários',
                            //             hint: 'Usuários',
                            //             disabled: false,
                            //             to: null
                            //         },
                            //         {
                            //             label: 'Análises Gerenciais',
                            //             hint: 'Análises Gerenciais',
                            //             disabled: false,
                            //             to: null
                            //         },
                            //         {
                            //             label: 'Relatórios',
                            //             hint: 'Relatórios',
                            //             disabled: false,
                            //             to: null
                            //         },
                            //     ]
                            // },
                        },
                        //DESCOMENTAR QUANDO ESTIVER FUNCIONANDO//
                        // {
                        //     type: 'dropdown-items',
                        //     hint: 'Favoritos',
                        //     icon: 'mdi-star-outline',
                        //     disabled: false,
                        //     class: 'hidden-sm-and-down',
                        //     items: [
                        //         {
                        //             label: 'Item 1',
                        //             hint: null,
                        //             icon: 'mdi-chevron-right-circle',
                        //             disabled: false,
                        //             to: null
                        //         },
                        //         {
                        //             label: 'Item 2',
                        //             hint: null,
                        //             icon: 'mdi-chevron-right-circle',
                        //             disabled: true,
                        //             to: null
                        //         },
                        //     ]
                        // }
                    ],
                    right: [
                        //DESCOMENTAR QUANDO ESTIVER FUNCIONANDO//
                        // {
                        //     type: 'button',
                        //     hint: 'Minhas Conversas',
                        //     icon: 'mdi-chat-processing',
                        //     disabled: false,
                        //     class: 'd-none d-sm-flex',
                        //     badge: {
                        //         text: '5',
                        //     },
                        //     click: this.chatOpen,
                        // },
                        // {
                        //     type: 'dropdown-items',
                        //     hint: 'Mensagens',
                        //     icon: 'mdi-bell',
                        //     disabled: false,
                        //     class: 'd-none d-sm-flex',
                        //     badge: {
                        //         text: '5',
                        //         color: 'warning'
                        //     },
                        //     items: [
                        //         {
                        //             label: 'Item 1',
                        //             hint: null,
                        //             icon: 'mdi-chevron-right-circle',
                        //             disabled: false,
                        //             to: null
                        //         },
                        //         {
                        //             label: 'Item 2',
                        //             hint: null,
                        //             icon: 'mdi-chevron-right-circle',
                        //             disabled: true,
                        //             to: null
                        //         },
                        //     ]
                        // },
                        // {
                        //     type: 'button',
                        //     hint: 'Agenda',
                        //     icon: 'mdi-calendar-month-outline',
                        //     disabled: false,
                        //     class: 'd-none d-sm-flex',
                        //     click: this.taskListOpen
                        // },
                        // {
                        //     type: 'button',
                        //     hint: 'Principais Moedas',
                        //     icon: 'mdi-currency-usd',
                        //     disabled: false,
                        //     class: 'hidden-sm-and-down',
                        //     click: this.currencyMonitorOpen,
                        // },
                        {
                            type: 'dropdown-user',
                            hint: null,
                            icon: null,
                            disabled: false,
                            user: {
                                username: this.$store.getters['auth/getUserName'],
                                firstname: this.$store.getters['auth/getFirstName'],
                                fullname: this.$store.getters['auth/getFullName'],
                                avatar: require('@/assets/imgs/usuario.png'), //icone do usuario no navbar
                                profile: this.$store.getters['auth/getUserRoles']  
                            },
                            items: [
                                //DESCOMENTAR QUANDO ESTIVER FUNCIONANDO
                                // {
                                //     label: ('dropdown.user.profile.label'),
                                //     hint: null,
                                //     icon: 'mdi-account',
                                //     disabled: false,
                                //     separator: true,
                                //     to: null
                                // },
                                // {
                                //     label: ('dropdown.user.changePassword.label'),
                                //     hint: null,
                                //     icon: 'mdi-lock',
                                //     disabled: false,
                                //     separator: false,
                                //     to: null
                                // },
                                {
                                    label: ('dropdown.user.exit.label'),
                                    hint: null,
                                    icon: 'mdi-exit-to-app',
                                    disabled: false,
                                    separator: true,
                                    click: this.handleLogout,
                                },
                            ]
                        },
                    ],
                },
                footerbar: {
                    color: 'thirteen',
                    items: [
                        {
                            label: null,
                            hint: null,
                            icon: null,
                            image: require('@/assets/imgs/logo/dark/xtpg-footer.png'),
                        },
                        {
                            label: ('footerbar.avisoPrivacidade.label'),
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                            click: () => window.open('/avisoPrivacidade/Termos de Uso e Aviso de Privacidade para os Produtos XTPG.pdf', '_blank')
                        },
                        {
                            label: ('footerbar.version.label'),
                            labelValue: '1.0.1',
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                            // to: 'sample_login',
                            // click: () => {
                            //     console.log('Chamando minha função ou metodo!');
                            // }
                        },
                        {
                            label: ('footerbar.position.label'),
                            //labelValue: this.dataPosicaoFormatada(),
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                        },
                        {
                            label: this.dataFormatada(),
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                        },
                        {
                            label: ('footerbar.env.label'),
                            labelValue: this.$store.state.auth.environment,
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                        },
                    ],
                    //descomentar quando estiver funcionando
                    // chat: {
                    //     label: ('footerbar.chat.label'),
                    //     hint: ('footerbar.chat.label'),
                    //     icon: 'mdi-chat-processing',
                    //     class: null,
                    //     click: this.chatOpen
                    // },
                },
                dataPosicao: null,
                pageview: {
                    tabs: {
                        onCloseAll: { name: 'home' },
                    }, 
                    /*
                    sidebar: {
                        open: true,
                        width: 240,
                        title: 'Assuntos Relacionados',
                        items: [
                            {
                                label: 'Clientes',
                                hint: null,
                                icon: 'mdi-account-group',
                                class: null,
                                to: 'home_customers',
                            },
                            {
                                label: 'Contatos',
                                hint: null,
                                icon: 'mdi-account-box',
                                class: null,
                                to: 'home_contacts',
                            },
                            {
                                label: 'Bancos',
                                hint: null,
                                icon: 'mdi-bank-outline',
                                class: null,
                                to: 'home_banks',
                            },
                            {
                                label: 'Financeiro',
                                hint: null,
                                icon: 'mdi-calculator',
                                class: null,
                                to: 'home_financial',
                            },
                            {
                                label: ('modules.reports.label'),
                                hint: null,
                                icon: 'mdi-finance',
                                class: null,
                                to: 'home_reports',
                            },
                            {
                                label: ('modules.countries.label'),
                                hint: 'null',
                                icon: 'mdi-flag',
                                class: null,
                                to: 'home_countries',
                            },
                            {
                                label: ('modules.entradaMovimentos.label'),
                                hint: 'null',
                                icon: 'mdi-flag',
                                class: null,
                                to: 'home_entradaMovimentos',
                            },
                            {
                                label: 'Países versão 1',
                                hint: 'null',
                                icon: 'mdi-flag',
                                class: null,
                                to: 'home_countriesVersao1',
                            },
                            {
                                label: 'Países versão 2',
                                hint: 'null',
                                icon: 'mdi-flag',
                                class: null,
                                to: 'home_countriesVersao2',
                            },
                            {
                                label: 'Países versão 3',
                                hint: 'null',
                                icon: 'mdi-flag',
                                class: null,
                                to: 'home_countriesVersao3',
                            },
                        ]
                    }, */
                },
            },
        }
    },
    methods: {
        async handleLogout() {
            // Verificar se foi feito o login SSO
            const isSSOLogin = localStorage.getItem('universe-sso-flag') === 'true';
            
            // Realizar logout
            await this.$store.dispatch('auth/actionLogout');
            
            // Redirecionar conforme o tipo de login realizado
            if (isSSOLogin) {
                // Para SSO, redirecionar para a página de logout 
                this.$router.push({ name: 'logout' });
            } else {
                // Para login tradicional, redirecionar para apágina de login
                this.$router.push({ name: 'login' });
            }
        },
        chatOpen() {
            this.$quickbarOpen('ChatMessages', {
                title: this.$t('quickbar.chatMessages.title'),
                icon: 'mdi-chat-processing',
                autoclose: false,
                overlay: false
            });
        },
        taskListOpen() {
            this.$quickbarOpen('TaskList', {
                title: this.$t('quickbar.taskList.title'),
                icon: 'mdi-calendar-month-outline'
            });
        },
        currencyMonitorOpen() {
            this.$quickbarOpen('CurrencyMonitor', {
                title: this.$t('quickbar.currencyMonitor.title'),
                icon: 'mdi-currency-usd'
            });
        },
        redirectToHome() {
            this.$router.push({ name: 'home' });
        },
        dataFormatada() {
            let dataAtual = new Date();
            let opcoes = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            let dataFormatadaAtual = dataAtual.toLocaleDateString(this.$i18n.locale, opcoes);
            return dataFormatadaAtual;
        },
        atualizarDataFormatada() {
            this.schema.footerbar.items[4].label = this.dataFormatada(); //campo data atual formatada do footerbar
            this.schema.footerbar.items[3].labelValue = this.dataPosicaoFormatada(); //campo data de posição formatada do footerbar
        },
        async getDataPosicao() {
            try {
                const urlApi = '/api/tesouraria/data-posicao';
                const response = await this.$store.dispatch('crud/crudGet', { apiRelativePath: urlApi, propertyName: 'dataPosicao'});
                this.dataPosicao = response.data.dataDePosicao;
            } catch (error) {
            }   
        },
        dataPosicaoFormatada() {
            let positionDate = new Date();
            let opcoes = {year: 'numeric', month: 'numeric', day: 'numeric'};
            let dataPosicaoFormatada = positionDate.toLocaleDateString(this.$i18n.locale, opcoes);
            return dataPosicaoFormatada;
        },

        //funcao de sincronização
        syncFullscreen() {
            this.isFullscreen = localStorage.getItem("isFullscreen") === "1";
        }
    },
      computed: { 
        isDashboardRoute() {
            return this.$route.name === 'home';
        }
    },
    watch: {
        '$i18n.locale': {
            handler() {
                this.atualizarDataFormatada();
                this.getDataPosicao();
            },
            immediate: true,
        },
        schema: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.$store.commit('sample/SET_SCHEMA', newVal);
            },
        }
    },

    mounted() {
        //escuta evento de mudança de  fullscreen
        document.addEventListener("fullscreenchange", () => {
            const isFullscreen = !!document.fullscreenElement;
            //salva o estado globalmente
            localStorage.setItem('isFullscreen', isFullscreen ? "1" : "0");
            //emitindo um evento personalizado para os outros componentes
            window.dispatchEvent(new Event("fullscreen-storage-sync"))
            //atualizando o proprio estado local
            this.syncFullscreen()
        });
        //escutando o evento personalizado de outros componentes
        window.addEventListener("fullscreen-storage-sync", this.syncFullscreen)
    },

    beforeDestroy(){
        //assim que o compoente for destruido, nao escuta mais esse evento
        window.removeEventListener("fullscreen-storage-sync", this.syncFullscreen)
    }
}
</script>

<style scoped>
.fade-enter{
    opacity: 0;
}
.fade-enter-active{
    transition: all .4s ease;
}

</style>
